import type { IntlShape } from "@formatjs/intl";
import { Col, Flex, Form, Input, Row, type FormInstance } from "antd";
import type { Client, Location } from "../generated-axios-client/index.ts";
import { ClientSelectorFormItem } from "./create-forms/ClientSelectorForm";
import { LocationSelectorFormItem } from "./create-forms/LocationSelectorFormItem";
import { Card } from "../../common/components/Card.tsx";

type TurbineFieldsProps = {
  intl: IntlShape;
  clientItems: Client[];
  locationItems: Location[];
  form: FormInstance;
};

export const TurbineFields = (props: TurbineFieldsProps) => {
  const { intl, clientItems, locationItems, form } = props;

  return (
    <Flex vertical gap="middle">
      <Card title={intl.formatMessage({ id: "turbine_section_details" })}>
        <Row gutter={24}>
          <Col xs={24} md={12}>
            <Form.Item
              name="serial_number"
              label={intl.formatMessage({ id: "turbine_serial_number" })}
              rules={[
                {
                  required: true,
                  pattern: /(^\d{5}$)/,
                  message: intl.formatMessage({
                    id: "validation_message_turbine_serial_number",
                  }),
                },
              ]}
            >
              <Input maxLength={5} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="park_number"
              label={intl.formatMessage({ id: "turbine_park_number" })}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={24} md={12}>
            <LocationSelectorFormItem
              intl={intl}
              locationItems={locationItems}
              form={form}
            />
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="manufacturer"
              label={intl.formatMessage({ id: "turbine_manufacturer" })}
            >
              <Input maxLength={250} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={24} md={12}>
            <Form.Item
              name="latitude"
              label={intl.formatMessage({ id: "turbine_latitude" })}
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "validation_message_turbine_latitude",
                  }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="longitude"
              label={intl.formatMessage({ id: "turbine_longitude" })}
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "validation_message_turbine_longitude",
                  }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={24} md={12}>
            <Form.Item
              name="service_lift"
              label={intl.formatMessage({ id: "turbine_service_lift" })}
            >
              <Input maxLength={240} showCount />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="fall_protection_system"
              label={intl.formatMessage({ id: "turbine_fall_protection_system" })}
            >
              <Input maxLength={240} showCount />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      <Card title={intl.formatMessage({ id: "turbine_section_assignment" })}>
        <Row gutter={24}>
          <Col xs={24} md={12}>
            <ClientSelectorFormItem clientItems={clientItems} intl={intl} form={form} />
          </Col>
        </Row>
      </Card>
    </Flex>
  );
};
